
export enum VehicleType {
    None = -1,
    Trailer = 0,
    Car = 1,
    BusOrPSV = 5,
    HgvLessThan12T = 6,
    Hgv12Tto22T = 7,
    HgvGreaterThan22T = 8,
    Lcv = 9,
    Motorcycle = 10,
    Unknown = 11,
    Asset = 12,
    Plant = 13
}
